module.exports = __webpack_public_path__ + "static/assets/b064ac23094b192d4e68a8eee99e7bf9.png";